import React from 'react'
import { Field, reduxForm } from 'redux-form';
import Dropzone from 'react-dropzone'

import ArtistPhoto from './ArtistPhoto'


class DashboardAvatar extends React.Component {

  render() {
    const { handleSubmit, pristine, submitting, error, fieldDisabled, artistPhoto } = this.props
    
    return (
      <form id="basic-info-form" onSubmit={ handleSubmit }>

        <Field 
          className="artist-photo-dropzone"
          name="photo" 
          component={ ArtistPhoto }
          artistphoto={artistPhoto}
          accept="image/jpeg,image/jpg,image/tiff,image/gif" 
          multiple={ false } 
          />

      </form>
    )
  }
}

export default reduxForm({
  form: 'artistDashboardAvatar', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(DashboardAvatar)





// WEBPACK FOOTER //
// ./src/components/DashboardAvatar.js